import service from '@/store/services/vendors/labourer-schedules-service';

const state = {
    list: {},
    labourerSchedule: {},
    meta: {},
    isLoading: false
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, labourerSchedule) => {
        state.labourerSchedule = labourerSchedule;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    },
    SET_LOADING: (state, status) => {
        state.isLoading = status;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        commit('SET_LOADING', true);
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
                commit('SET_LOADING', false);
            }).catch((error) => {
                commit('SET_LOADING', false);
                throw error;
            });
    },

    get ({ commit, dispatch }, params) {
        commit('SET_LOADING', true);
        return service.get(params)
            .then(labourerSchedule => {
                commit('SET_RESOURCE', labourerSchedule);
                commit('SET_LOADING', false);
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },

    view ({ commit, dispatch }, params) {
        commit('SET_LOADING', true);
        return service.view(params)
            .then(labourerSchedule => {
                commit('SET_RESOURCE', labourerSchedule);
                commit('SET_LOADING', false);
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },
    show ({ commit, dispatch }, params) {
        commit('SET_LOADING', true);
        return service.show(params)
            .then(labourerSchedule => {
                commit('SET_RESOURCE', labourerSchedule);
                commit('SET_LOADING', false);
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },
    add ({ commit, dispatch }, params) {
        commit('SET_LOADING', true);
        return service.add(params)
            .then((labourerSchedule) => {
                commit('SET_RESOURCE', labourerSchedule);
                commit('SET_LOADING', false);
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },

    update ({ commit, dispatch }, params) {
        commit('SET_LOADING', true);
        return service.update(params)
            .then((labourerSchedule) => {
                commit('SET_RESOURCE', labourerSchedule);
                commit('SET_LOADING', false);
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },
    upload ({ commit, dispatch }, { labourerSchedule, image }) {
        commit('SET_LOADING', true);
        return service.upload(labourerSchedule, image)
            .then((url) => {
                commit('SET_URL', url);
                commit('SET_LOADING', false);
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
    reset ({ commit, dispatch }, { id, comment }) {
        return service.reset(id, comment);
    },

    checkin ({ commit, dispatch }, params) {
        return service.checkin(params)
            .then((labourerSchedule) => {
                commit('SET_LOADING', false);
                commit('SET_RESOURCE', labourerSchedule);
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },

    checkinSupervisor ({ commit, dispatch }, params) {
        return service.checkinSupervisor(params)
            .then((labourerSchedule) => {
                commit('SET_LOADING', false);
                commit('SET_RESOURCE', labourerSchedule);
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },

    reRunAssignment ({ commit, dispatch }, params) {
        return service.reRunAssignment(params)
            .then((labourerSchedule) => {
                commit('SET_LOADING', false);
                commit('SET_RESOURCE', labourerSchedule);
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },

    checkoutSupervisor ({ commit, dispatch }, params) {
        return service.checkoutSupervisor(params)
            .then((labourerSchedule) => {
                commit('SET_LOADING', false);
                commit('SET_RESOURCE', labourerSchedule);
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },

    checkout ({ commit, dispatch }, params) {
        return service.checkout(params)
            .then((labourerSchedule) => {
                commit('SET_LOADING', false);
                commit('SET_RESOURCE', labourerSchedule);
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },


    supervisorList({ commit }, params = {}) {
        commit('SET_LOADING', true);
        return service.supervisorList(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
                commit('SET_LOADING', false);
                return { list, meta };
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },

    manualCheckIn({ commit }, params) {
        commit('SET_LOADING', true);
        return service.manualCheckIn(params)
            .then((labourerSchedule) => {
                commit('SET_RESOURCE', labourerSchedule);
                commit('SET_LOADING', false);
                return labourerSchedule;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },

    manualCheckOut({ commit }, params) {
        commit('SET_LOADING', true);
        return service.manualCheckOut(params)
            .then((labourerSchedule) => {
                commit('SET_RESOURCE', labourerSchedule);
                commit('SET_LOADING', false);
                return labourerSchedule;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },

    syncPunchs({ commit }, params) {
        commit('SET_LOADING', true);
        return service.syncPunchs(params)
            .then((labourerSchedule) => {
                commit('SET_RESOURCE', labourerSchedule);
                commit('SET_LOADING', false);
                return labourerSchedule;
            })
            .catch(error => {
                commit('SET_LOADING', false);
                throw error;
            });
    },
    generateShiftAssignmentPdf({dispatch}, { filters }) {
        return service.generateShiftAssignmentPdf(filters)
            .then(response => {
                return response.data;
            });
    },
    shiftAssignmentPdfStatus({dispatch}, { reportId }) {
        return service.shiftAssignmentPdfStatus(reportId);
    },
    previewShiftAssignmentPdf({dispatch}, { reportId }) {
        return service.previewShiftAssignmentPdf(reportId);
    },
    downloadShiftAssignmentPdf({dispatch}, { reportId }) {
        return service.downloadShiftAssignmentPdf(reportId);
    }
};

const getters = {
    list: state => state.list,
    url: state => state.url,
    listTotal: state => state.meta.page.total || 0,
    labourerSchedule: state => state.labourerSchedule,
    isLoading: state => state.isLoading,
    dropdown: (state) => {
        return state.list.map(labourerSchedule => ({
            id: labourerSchedule.id,
            first_name: labourerSchedule.first_name,
            last_name: labourerSchedule.last_name,
            middle_name: labourerSchedule.middle_name
        }));
    }
};

const labourerSchedules = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default labourerSchedules;
